import { WhatsAppIcon } from "@/components/WhatsAppIcon";
import { buttonClass } from "@/components/ui/button";
import { usePlatform } from "@/lib/queries";
import { cn } from "@/lib/cn";
import { t } from "@/i18n/id";

export function helpWhatsappUrl(number: string | undefined, message?: string): string | null {
  if (!number || !/^62\d{8,13}$/.test(number)) return null;
  return `https://wa.me/${number}?text=${encodeURIComponent(message || t.common.helpWhatsappMessage)}`;
}

/** "Bantuan" → WhatsApp chat with the Baze team (number from /public/platform). */
export function HelpButton({ compact, className }: { compact?: boolean; className?: string }) {
  const { data } = usePlatform();
  const href = helpWhatsappUrl(data?.whatsapp, data?.whatsappMessage);
  if (!href) return null;
  return (
    <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={cn(buttonClass("ghost", compact ? "icon-sm" : "sm"), "text-slate-600", className)}
        aria-label={compact ? t.shell.help : undefined}
        title={t.shell.helpTooltip}
      >
        <WhatsAppIcon className="size-4 text-whatsapp" />
        {compact ? null : <span className="hidden sm:inline">{t.shell.help}</span>}
      </a>
  );
}
